var _rect, _rect2, _rect3, _ellipse, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcon2 = function SvgIcon2(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 41,
    viewBox: "0 0 69 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6133,
    width: 8.59702,
    height: 4.83582,
    fill: "#8e939f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 7,
    width: 7,
    height: 4,
    fill: "#8e939f"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 14,
    width: 6,
    height: 3,
    fill: "#cdd2d7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.6418,
    cy: 27.6718,
    rx: 11.6418,
    ry: 11.7313,
    fill: "#cdd2d7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.7761,
    cy: 24.6267,
    r: 14.7761,
    fill: "#8e939f"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8209,
    cy: 21.5821,
    r: 17.8209,
    fill: "#1d2535"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 29.5C3 29.5 3 29 4 29C5 29 5 29.5 5 29.5V38.5H3V29.5Z",
    fill: "#cdd2d7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29.5C31 29.5 31 29 32 29C33 29 33 29.5 33 29.5V38.5H31V29.5Z",
    fill: "#cdd2d7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 29.5C17 29.5 17 29 18 29C19 29 19 29.5 19 29.5V38.5H17V29.5Z",
    fill: "#cdd2d7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7435 38.4818H8V0.371748C8 0.166487 8.16649 0 8.37175 0C8.57734 0 8.7435 0.166487 8.7435 0.371748V38.4818Z",
    fill: "#cdd2d7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3334 38.4818H11.5898V0.371748C11.5898 0.166487 11.7564 0 11.9616 0C12.1672 0 12.3334 0.166487 12.3334 0.371748V38.4818Z",
    fill: "#cdd2d7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52539 4.04101H11.8171V3.50244H8.52539V4.04101Z",
    fill: "#cdd2d7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52539 7.39892H11.8171V6.86035H8.52539V7.39892Z",
    fill: "#cdd2d7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52539 10.7567H11.8171V10.2178H8.52539V10.7567Z",
    fill: "#cdd2d7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52539 14.1147H11.8171V13.5762H8.52539V14.1147Z",
    fill: "#cdd2d7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52539 17.4727H11.8171V16.9341H8.52539V17.4727Z",
    fill: "#cdd2d7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52539 20.8309H11.8171V20.292H8.52539V20.8309Z",
    fill: "#cdd2d7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52539 24.1885H11.8171V23.6499H8.52539V24.1885Z",
    fill: "#cdd2d7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52539 27.5464H11.8171V27.0078H8.52539V27.5464Z",
    fill: "#cdd2d7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52539 30.9046H11.8171V30.3657H8.52539V30.9046Z",
    fill: "#cdd2d7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52539 34.2622H11.8171V33.7236H8.52539V34.2622Z",
    fill: "#cdd2d7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52539 37.6201H11.8171V37.0815H8.52539V37.6201Z",
    fill: "#cdd2d7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 38,
    width: 67,
    height: 3,
    fill: "#1d2535"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon2.d6e69661.svg";
export { ForwardRef as ReactComponent };